"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _zh_CN = _interopRequireDefault(require("../locale/zh_CN"));
var _default = exports["default"] = _zh_CN["default"];